import React from "react";
import SEO from "../../components/SEO.jsx";
import ProposalPage from "../../components/proposals/ProposalPage.jsx";
import AdminStatus from "../../components/AdminStatus.jsx";
import NotFound from "../NotFound.jsx";
import useAdminDocument from "../../hooks/useAdminDocument.js";
import "../../styles/proposals.css";

// Proposal content and payment details are loaded from the admin API after
// server-side login; nothing confidential is bundled.
export default function JmdsProposalPage() {
  const proposal = useAdminDocument("proposal", "jmds");
  const business = useAdminDocument("business");

  if (proposal.status === "not-found") return <NotFound title="Proposal not found" />;
  if (proposal.status === "error" || business.status === "error") {
    return <AdminStatus message="Unable to load this proposal." detail={proposal.error || business.error} />;
  }
  if (proposal.status !== "ready" || business.status !== "ready") {
    return <AdminStatus message="Loading proposal…" />;
  }

  return (
    <>
      <SEO
        title={proposal.data.meta?.title}
        description={proposal.data.hero?.intro}
        path="/proposal/jmds"
        noindex
      />
      <ProposalPage proposal={proposal.data} payment={business.data?.proposalPayment || {}} />
    </>
  );
}
